<template>
  <div class="page-contract-search mwclg-style">
    <div class="order-search" >
      <div class="flex">
        <el-form ref="searchForm" :model="searchForm" style="flex: 1" label-width="100px">
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item :label="$t('DomesticWarehousing.OrderNumber') ">
                <el-input v-model="searchForm.ownerOrderNo" size="small"
                  :placeholder="$t('DomesticWarehousing.PleaseEnter') "></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="PO No" label-width="125px">
                <el-input v-model="searchForm.poNoContains" size="small"
                  :placeholder="$t('DomesticWarehousing.PleaseEnter') ">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('DomesticWarehousing.MaterialNumber') " label-width="125px">
                <el-input v-model="searchForm.ownerCargoCodeContains" size="small"
                  :placeholder="$t('DomesticWarehousing.PleaseEnter') ">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item :label="$t('DomesticWarehousing.BatchNumber') ">
                <el-input v-model="searchForm.batchNoContains" size="small"
                  :placeholder="$t('DomesticWarehousing.PleaseEnter') "></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('DomesticWarehousing.MaterialName') " label-width="125px">
                <el-input v-model="searchForm.cargoNameCnContains" size="small"
                  :placeholder="$t('DomesticWarehousing.PleaseEnter') ">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('DomesticWarehousing.EnglishName') " label-width="125px">
                <el-input v-model="searchForm.cargoNameEnContains" size="small"
                  :placeholder="$t('DomesticWarehousing.PleaseEnter') ">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="UB">
                <el-input v-model="searchForm.ubContains" size="small"
                  :placeholder="$t('DomesticWarehousing.PleaseEnter') "></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('DomesticWarehousing.Standards') " label-width="125px">
                <el-input v-model="searchForm.specificationContains" size="small"
                  :placeholder="$t('DomesticWarehousing.PleaseEnter') ">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- <el-form-item :label="$t('DomesticWarehousing.DateFrom') ">
                <el-date-picker size="small" v-model="searchForm.finishDTFrom" type="date" value-format="yyyy-MM-dd"
                  :placeholder="$t('DomesticWarehousing.PleaseSelectDate') ">
                </el-date-picker>
              </el-form-item> -->
              <el-form-item :label="$t('DomesticWarehousing.DateFrom')" label-width="125px">
                <!-- <el-date-picker v-model="orderDate" type="daterange" range-separator="~"
                  :start-placeholder="$t('DomesticWarehousing.DateFrom')"
                  :end-placeholder="$t('DomesticWarehousing.DateTo')" :picker-options="pickerOptions"
                  @change="searchTimeChange">
                </el-date-picker> -->
                <el-date-picker v-model="CreateInterval" type="daterange" range-separator="~"
                  format="yyyy-MM-dd" value-format="yyyy-MM-dd" size="small"  class="custom-input"
                  />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item :label="$t('DomesticWarehousing.Warehouse') " label-width="125px">
                <el-select v-model="whName" filterable remote :placeholder="$t('DomesticWarehousing.PleaseEnter') "
                  :remote-method="remoteMethod" :loading="loading">
                   remote-method封装好的钩子函数。当用户在输入框中输入内容的时候，会触发这个函数的执行，
      把输入框对应的值作为参数带给回调函数，loading的意思就是远程搜索的时候等待的时间，即：加载中
                  <el-option v-for="item in options" :key="item.whID" :label="item.whName" :value="item.whName">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
          </el-row>
        </el-form>
        <div style="margin: 0 22px; width: 0.5px; background: #f3f4f6"></div>
        <div style="margin-top: 10px">
          <el-button type="primary" size="small" icon="el-icon-search" @click="search">{{
            $t('DomesticWarehousing.Query') }}</el-button>
          <el-button size="small" icon="el-icon-refresh-right" @click="reset">{{
            $t('DomesticWarehousing.Reset') }}</el-button>
          <el-button size="small" icon="el-icon-download" @click="exportExcel">{{
            $t('DomesticWarehousing.Export') }}</el-button>
        </div>
      </div>
    </div>
    <div class="order-list">
      <p class="title">
        {{ $t('DomesticWarehousing.InboundList') }}
      </p>
      <div>
        <el-table v-loading="loading" :data="dataItems" stripe show-summary :summary-method="getSummaries" size="medium"
          :row-key="tableRowKey" :expand-row-keys="expandRowKeys" @expand-change="tableExpandChange"
          @row-click="rowClick" :row-class-name="tableRowClassName">
          <el-table-column type="expand">
            <template slot-scope="scope">
              <!-- 自定义编写 -->
              <div class="milestone">
                <div style="width: 45%;">
                  <OrderStep :statu-list="getMilestoneData(scope.row)" />
                </div>
              </div>
              <!-- <div class="expand-content">
                <div>
                  <div>{{ scope.row.ownerOrderNo }}</div>
                  <div>{{ scope.row.finishDT }}</div>
                </div>
              </div> -->
            </template>
          </el-table-column>
          <!-- <el-table-column header-align="center" align="center" width="100" label="操作">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-plus" size="small" @click.stop="add(scope.row)">查看附件</el-button>
            </template>
          </el-table-column> -->
          <el-table-column prop="detailID" v-if="false" min-width="130" label="ID">
          </el-table-column>
          <el-table-column prop="ownerOrderNo" min-width="180" :label="$t('DomesticWarehousing.OrderNumber')">
          </el-table-column>
          <el-table-column min-width="180" prop="finishDT" :label="$t('DomesticWarehousing.InboundDate')">
          </el-table-column>
          <el-table-column min-width="180" prop="ownerCargoCode" :label="$t('DomesticWarehousing.MaterialNumber')">
          </el-table-column>
          <el-table-column min-width="240" prop="cargoNameCn" :label="$t('DomesticWarehousing.MaterialName')">
          </el-table-column>
          <el-table-column min-width="240" prop="cargoNameEn" :label="$t('DomesticWarehousing.EnglishName')">
          </el-table-column>
          <el-table-column min-width="120" prop="ub" label="UB">
          </el-table-column>
          <el-table-column min-width="120" prop="specification" :label="$t('DomesticWarehousing.Standards')">
          </el-table-column>
          <el-table-column min-width="140" prop="controlType" :label="$t('DomesticWarehousing.ControlType')">
          </el-table-column>
          <el-table-column min-width="120" prop="batchNo" :label="$t('DomesticWarehousing.BatchNumber')">
          </el-table-column>
          <el-table-column min-width="150" prop="qty" :label="$t('DomesticWarehousing.PackagingQty')">
          </el-table-column>
          <el-table-column min-width="150" prop="perUnitCode" :label="$t('DomesticWarehousing.PackagingUnit')">
          </el-table-column>
          <el-table-column min-width="150" prop="baseQty" :label="$t('DomesticWarehousing.BasicQty')">
          </el-table-column>
          <el-table-column min-width="100" prop="baseUnitCode" :label="$t('DomesticWarehousing.BasicUnit')">
          </el-table-column>
          <el-table-column min-width="100" prop="netWeightText" :label="$t('DomesticWarehousing.NetWeight')">
          </el-table-column>
          <el-table-column min-width="120" prop="grossWeightText" :label="$t('DomesticWarehousing.GrossWeight')">
          </el-table-column>
          <el-table-column min-width="100" prop="poNo" label="PO No">
          </el-table-column>
          <!-- <el-table-column min-width="180" prop="whName" :label="$t('DomesticWarehousing.WarehouseName')">
          </el-table-column> -->
        </el-table>
      </div>
    </div>
    <div class="pagination-info">
      <div style="color:#999;font-size: 12px;margin-left: 220px;"></div>
      <el-pagination background align='left' @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="searchForm.pageNo" :page-size.sync="searchForm.pageSize"
        :page-sizes="[10, 20, 50, 100, 1000, 2000]" layout='total, sizes, prev, pager, next, jumper'
        :total="dataCount" />
    </div>
  </div>
</template>
<script>
import BarChart from '@/components/wms/barChart'
// import { axios } from '@/utils/request'
import OrderStep from '@/components/wms/orderStep/index.vue'
import {
  parseTime,
  dateAdds
} from '@/utils/index'
// import { convertYMD, conversionTime, parseTime, dateAddDays } from '@/utils/index'
// import { ISStr, EnumValueLocal } from '@/utils/isClass'
import i18n from '@/i18n/i18n'
import { getSearchInboundDataApi, api, getWarehouseDataApi, getGetMilestoneDetailApi } from '@/api/wms'
export default {
  components: {
    BarChart,
    OrderStep
  },
  props: {
    jobType: {
      type: String,
      default: 'DC'
    },
    customerCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchForm: {
        ownerOrderNo: '',
        poNoContains: '',
        ownerCargoCodeContains: '',
        batchNoContains: '',
        cargoNameCnContains: '',
        cargoNameEnContains: '',
        ubContains: '',
        specificationContains: '',
        finishDTFrom: '',
        finishDTTo: '',
        whName: '',
        Lang: '',
        customerCode: this.customerCode,
        pageNo: 1,
        pageSize: 10,
      },
      loading: false,
      whName: '',
      dataCount: 0,
      dataItems: [],
      wareHouseList: [],
      options: [],
      CreateInterval: [
        parseTime(dateAdds(new Date(), -15, 'd'), '{y}-{m}-{d}'),
        parseTime(new Date(), '{y}-{m}-{d}')
      ], 
      tableRowKey: 'detailID',
      expandRowKeys: [],
    }
  },
  computed: {},
  mounted() {
    this.search();
    //this.GetWareHouseData();
  },
  methods: {
    async search() {
      this.loading = true
      this.searchForm.finishDTFrom = this.CreateInterval[0];
      this.searchForm.finishDTTo = this.CreateInterval[1];
      const lang = this.$ls.get('lang');
      const params = this.searchForm
      params.whName = this.whName;
      params.Lang = lang;
      console.log(this.searchForm.finishDTFrom);
      if (this.searchForm.finishDTFrom == '' || this.searchForm.finishDTFrom == null) {
        this.$message({
          message: i18n.t('DomesticWarehousing.StartTimeEm'),
          type: 'warning'
        });
        this.loading = false
        return false;
      }
      if (this.searchForm.finishDTTo == '' || this.searchForm.finishDTTo == null) {
        this.$message({
          message: i18n.t('DomesticWarehousing.EndTimeEn'),
          type: 'warning'
        });
        this.loading = false
        return false;
      }
      var startdate = new Date(this.searchForm.finishDTFrom);
      var enddate = new Date(this.searchForm.finishDTTo);
      var startMonth = new Date(startdate.setMonth(startdate.getMonth() + 1));
      if (enddate > startMonth) {
        this.$message({
          message: i18n.t('DomesticWarehousing.DateMonthCanNot'),
          type: 'warning'
        });
        this.loading = false
        return false;
      }
      var res = await getSearchInboundDataApi(params)
      if (res && res.code == 200) {
        var data = res.data
        this.dataItems = data.items
        this.dataCount = data.count
      } else {
        this.messagebox.alert('查询失败')
      }
      this.loading = false
    },
    exportExcel() {
      this.searchForm.finishDTFrom = this.CreateInterval[0];
      this.searchForm.finishDTTo = this.CreateInterval[1];
      if (this.searchForm.finishDTFrom == '' || this.searchForm.finishDTFrom == null) {
        this.$message({
          message: i18n.t('DomesticWarehousing.StartTimeEm'),
          type: 'warning'
        });
        this.loading = false
        return false;
      }
      if (this.searchForm.finishDTTo == '' || this.searchForm.finishDTTo == null) {
        this.$message({
          message: i18n.t('DomesticWarehousing.EndTimeEn'),
          type: 'warning'
        });
        this.loading = false
        return false;
      }
      const lang = this.$ls.get('lang');
      this.searchForm.Lang = lang;
      var startdate = new Date(this.searchForm.finishDTFrom);
      var enddate = new Date(this.searchForm.finishDTTo);
      var startMonth = new Date(startdate.setMonth(startdate.getMonth() + 1));
      if (enddate > startMonth) {
        this.$message({
          message: i18n.t('DomesticWarehousing.DateMonthCanNot'),
          type: 'warning'
        });
        this.loading = false
        return false;
      }
      var queryString = Object.keys(this.searchForm).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(this.searchForm[key])
      }).join('&')
      const url = api.exportSearchInboundDataApiUrl + '?' + queryString
      window.location.href = url
    },
    async GetWareHouseData() {
      const params = {Lang: ''};
      params.Lang = this.$ls.get('lang');
      var result = await getWarehouseDataApi(params)
      this.wareHouseList = result.data;
    },
    // 展开行
    tableExpandChange(expandedRows) {
      this.expandCurRow(expandedRows)
    },
    // 点击某行
    rowClick(row) {
      this.expandCurRow(row)
    },
    // 点击展开/收缩当前行
    expandCurRow(row) {
      if (this.expandRowKeys.length) { // 点击已展开的行 就要收起
        if (this.expandRowKeys.indexOf(row[this.tableRowKey]) >= 0) {
          this.expandRowKeys = []
          return
        }
      }
      this.expandRowKeys = [row[this.tableRowKey]]
    },
    tableRowClassName({ row, rowIndex }) {
      return 'warning-row';
    },
    /**  节点 */
    getMilestoneData(item) {
      console.log(item);
      // this.milestoneSearch.ownerOrderNo = item.ownerOrderNo;
      // const params = this.milestoneSearch;
      // // var queryString = Object.keys(this.milestoneSearch).map((key) => {
      // //   return encodeURIComponent(key) + '=' + encodeURIComponent(this.milestoneSearch[key])
      // // }).join('&')
      // // const url = api.getGetMilestoneDetailUrl + '?' + queryString
      // var res = axios({
      //   url: api.getGetMilestoneDetailUrl,
      //   method: 'get',
      //   params
      // }).then(response => {
      //   if (response && response.code == 200) {
      //     this.milestoneData = response.data
      //   } else {
      //     this.messagebox.alert('查询失败')
      //   }
      // });
      const data = [];
      // var timeList = this.milestoneTime(item)
      try {
        // 精准匹配
        // const serviceRequests = item.ServiceRequest?.split(',');
        // const isDC = serviceRequests?.includes('订舱')
        // const isBG = serviceRequests?.includes('报关')
        data.push({ Name: i18n.t('DomesticWarehousing.Initial'), EventDT: item.createTime, OpenImg: require('@/assets/wms/初始.png'), ShutImg: require('@/assets/wms/初始.png') })
        data.push({ Name: i18n.t('DomesticWarehousing.Confirmed'), EventDT: item.submitTime, OpenImg: require('@/assets/wms/确单.png'), ShutImg: require('@/assets//wms/确单.png') })
        data.push({ Name: i18n.t('DomesticWarehousing.Entry'), EventDT: item.callInTime, OpenImg: require('@/assets/wms/待进场.png'), ShutImg: require('@/assets/wms/待进场.png') })
        data.push({ Name: i18n.t('DomesticWarehousing.Receipt'), EventDT: item.receiveTime, OpenImg: require('@/assets/wms/收货.png'), ShutImg: require('@/assets/wms/收货.png') })
        data.push({ Name: i18n.t('DomesticWarehousing.CompleteReceipt'), EventDT: item.receiveFinish, OpenImg: require('@/assets/wms/收货完成.png'), ShutImg: require('@/assets/wms/收货完成.png') })
        return data
      } catch (error) {
        return data
      }
    },
    remoteMethod(query) {
      // 如果用户输入内容了，就发请求拿数据，远程搜索模糊查询
      if (query !== '') {
        this.loading = true; // 开始拿数据喽
        // 这里模拟发请求，res就当成发请求返回来的数据吧。
        this.loading = false // 拿到数据喽
        // 然后把拿到的所有数据，首先进行一个过滤，把有关联的过滤成一个新数组给到options使用
        this.options = this.wareHouseList.filter((item) => {

          // indexOf等于0代表只要首个字匹配的，如：搜索 王  王小虎数据会被过滤出来，但是 小虎王的数据不会被过滤出来。因为indexOf等于0代表以什么开头
          // return item.label.toLowerCase().indexOf(query.toLowerCase()) == 0

          // indexOf大于-1代表的是，只要有这个字出现的即可，如：搜索 王 王小虎、小虎王、小王虎都会被过滤出来。因为indexOf找不到才会返回-1，
          // 大于-1说明只要有就行，不论是不是开头也好，中间也好，或者结尾也好
          return item.whName.toLowerCase().indexOf(query.toLowerCase()) > -1
        })
      } else {
        this.options = [];
      }
    },
    getCurrentTime() {
      var date = new Date()
      date.setDate(1)
      var month = parseInt(date.getMonth() + 1)
      var day = date.getDate()
      if (month < 10) month = '0' + month
      if (day < 10) day = '0' + day
      this.searchForm.finishDTFrom = date.getFullYear() + '-' + month + '-' + day
    },
    getCurrentMonthStart() {
      var date = new Date()
      var month = parseInt(date.getMonth() + 1)
      var day = date.getDate()

      if (month < 10) month = '0' + month
      if (day < 10) day = '0' + day
      this.searchForm.finishDTTo = date.getFullYear() + '-' + month + '-' + day
    },
    reset() {
      this.whName = ''
      this.searchForm = {
        ownerOrderNoContains: '',
        poNoContains: '',
        ownerCargoCodeContains: '',
        batchNoContains: '',
        cargoNameCnContains: '',
        cargoNameEnContains: '',
        ubContains: '',
        whName: '',
        specificationContains: '',
        //startDate: '',
        //endDate: '',
        customerCode: this.customerCode,
        pageNo: 1,
        pageSize: this.searchForm.pageSize,
      }
    },
    handleSizeChange(val) {
      this.searchForm.pageNo = 1;
      this.searchForm.pageSize = val;
      this.search()
    },
    // 当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.searchForm.pageNo = val;
      this.search()
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      // 保留换行符    选中合计行的每一个元素，然后给每一个元素都添加css样式whiteSpace。
      this.$nextTick(() => {
        const elements = document.querySelectorAll(
          '.el-table__footer-wrapper div.cell'
        );
        elements.forEach(element => {
          // whiteSpace用于控制元素内部空白符（包括空格、换行符等）的处理方式。pre-wrap：表示浏览器会保留连续的空白符和换行符，且会自动换行。
          element.style.whiteSpace = 'pre-wrap';
        });
      });
      // 以下是对小计和总计分别进行赋值
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = i18n.t('DomesticWarehousing.Total');
          return;
        }
        // 将当前列的所有值存储到values中  注：非数字会返回NaN
        const values = data.map(item => Number(item[column.property]));
        // 将要进行小计合计的字段组成一个数组
        const label = ['qty', 'netWeight', 'grossWeight'];
        // 如果label包含当前column.property，则进行数据处理
        if (label.includes(column.property)) {
          // 小计
          const Subtotal = values
            .reduce((prev, curr) => {
              const value = Number(curr);
              // 如果是数字则进行累加
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
            .toFixed(2);
          // 总计
          sums[index] = Subtotal;
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
  },
}
</script>
<style scoped>
.order-search {
  margin-top: 10px;
  background: white;
  border-radius: 4px;
  padding: 10px 10px;
  height:auto !important;
}

.order-list {
  background: white;
  margin-top: 10px;
  border-radius: 4px;
  padding: 10px 10px;
}

.order-list .list-item {
  margin-bottom: 8px;
}

.title {
  font-size: 16px;
  font-weight: 600;
  color: #100f0f;
  line-height: 22px;
  margin-bottom: 10px;
}
.w100 {
  width: 100%;
}
.node {
  width: 130px;
  color: #9ca3af;
}
.nodeActivate {
  color: #111827;
  font-weight: 600;
}
.line {
  width: calc(100% - 130px);
  color: #e9ecf2;
}
.lineActivate {
  color:  #67b0c4;
}
.lineLeft {
  padding-left: 10%;
  width: 100%;
  /* border-top: 2px dashed; */
  border-top: 1px solid;
}
.div-svg {
  width: 60px;
  height: 60px;
  display: flex;
  overflow: hidden;
}
.div-value {
  width: calc(100% - 0px);
  text-align: center;
}
.svg-icon {
  position: relative;
  left: -80px;
  filter: drop-shadow(#3809f3 80px 0);
}
.div-img{
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}
.div-img img {
  width: 28px;
  height: 28px;
}
.milestone{
  /* padding: 21px 50px 15px 21px; */
  background: #f3f8fa;
  margin: 20px;
}
</style>
<style>
.el-select,
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

.tms-style .el-input__inner {
  max-width: none;
}

.el-loading-mask {
  z-index: 1000;
}

.pagination-info {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 36px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    z-index: 3;
  }
</style>
